import {createTheme, responsiveFontSizes} from '@mui/material'


import {typography} from './typography'
import {themeComponents} from './components'
import {darkPalette, lightPalette} from './palette'


const stdyDarkTheme = createTheme({
  palette: darkPalette,
  typography
})

const stdyLightTheme = createTheme({
  palette: lightPalette,
  typography
})

const paletteTheme = stdyLightTheme
export const stdyTheme = responsiveFontSizes(createTheme(
  paletteTheme,
  {
    shape: {},
    components: themeComponents(paletteTheme)
  }
))
